"use client";

import * as Sentry from "@sentry/nextjs";
import React, { useEffect } from "react";

export default function NotFound({
  error,
}: {
  error: Error & { digest?: string };
}) {
  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  return (
    <>
      <div className="min-h-screen flex items-center justify-center bg-white">
        <div className="w-full max-w-md mx-3 bg-white p-10 rounded-lg shadow-lg text-center">
          <h1 className="text-2xl font-bold text-gree-700 mb-4">Oops!</h1>
          <p className="text-gray-600 mb-8">
            We couldn&apos;t find the page you were looking for
          </p>
        </div>
      </div>
    </>
  );
}
